var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718_79595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 0.800781C4.0236 0.800781 0.800049 4.02433 0.800049 8.00078C0.800049 11.9772 4.0236 15.2008 8.00005 15.2008C11.9765 15.2008 15.2 11.9772 15.2 8.00078C15.2 4.02433 11.9765 0.800781 8.00005 0.800781ZM11.0748 6.16765C11.2774 5.90544 11.2291 5.52863 10.9669 5.32601C10.7047 5.12339 10.3279 5.1717 10.1253 5.43391L7.16497 9.2649L5.84602 7.7994C5.62435 7.55309 5.24498 7.53313 4.99867 7.7548C4.75236 7.97648 4.7324 8.35585 4.95407 8.60216L6.75407 10.6022C6.87311 10.7344 7.04471 10.807 7.22252 10.8004C7.40034 10.7937 7.56602 10.7084 7.67482 10.5676L11.0748 6.16765Z",
    fill: "#1EA939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718_79595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9f3dbdfff4fbf7b6fd3d96af253b6b94.svg";
export { ForwardRef as ReactComponent };